/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-12-24 17:29:25
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-12 14:17:23
 * @Description: file content
 */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import routerBefore from './routerBefore'
import { codStatisticsManage, sysSetting, packManage, fundManage } from './route'
import { NameEnum, UrlEnum, UnionEnum } from '@/utils/enums/Route'

const Layout = () => import('@/layout/index.vue')
const Login = () => import('@/views/login/Index.vue')
const findPwd = () => import('@/views/findPwd/Index.vue')

const Home = () => import('@/views/home/Index.vue')
const NotFound = () => import('@/views/notfound/Index.vue')
const NoAuth = () => import('@/views/noauth/Index.vue')
const routes: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.Home],
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: UrlEnum[UnionEnum.Home],
        name: 'Home',
        component: Home,
        meta: { title: NameEnum[UnionEnum.Home], requiresAuth: false, keepAlive: true }
      },
      {
        path: UrlEnum[UnionEnum.NOTFOUND],
        name: 'NotFound',
        component: NotFound,
        meta: { title: NameEnum[UnionEnum.NOTFOUND], requiresAuth: false, keepAlive: true }
      },
      {
        path: UrlEnum[UnionEnum.NOAUTH],
        name: 'NoAuth',
        component: NoAuth,
        meta: { title: NameEnum[UnionEnum.NOAUTH], requiresAuth: false, keepAlive: true }
      },
      {
        path: UrlEnum[UnionEnum.DownLoad],
        name: 'DownLoadCenter',
        component: () => import('@/views/download/Index.vue'),
        meta: { title: NameEnum[UnionEnum.DownLoad], requiresAuth: true, keepAlive: true }
      },
      {
        path: '/temp',
        name: 'temp',
        component: () => import('@/print/tmp_idn/index.vue'),
        meta: { title: '打印模版预览', requiresAuth: false, keepAlive: false }
      },
      ...codStatisticsManage,
      ...sysSetting,
      ...packManage,
      ...fundManage
    ]
  },
  {
    path: UrlEnum[UnionEnum.LOGIN],
    name: 'Login',
    component: Login,
    meta: { title: NameEnum[UnionEnum.LOGIN], requiresAuth: false, keepAlive: false }
  },
  {
    path: UrlEnum[UnionEnum.FINDPASSWORD],
    name: 'findPwd',
    component: findPwd,
    meta: { title: NameEnum[UnionEnum.FINDPASSWORD], requiresAuth: false, keepAlive: false }
  },
  {
    path: '/smsCode',
    name: 'SmsCode',
    component: () => import('@/views/login/SmsCode.vue'),
    meta: { title: '认证', requiresAuth: false, keepAlive: false }
  },
  {
    path: '/:w+',
    name: '*',
    redirect: UrlEnum[UnionEnum.NOTFOUND]
  }
]

const index = createRouter({
  history: createWebHistory(),
  routes
})
//路由导航
routerBefore(index)
export default index
